import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {Line, Bar} from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, BarElement, CategoryScale, Title, Tooltip, Legend } from 'chart.js';

//toFactDate, fromFactDate, alterDate, isFactDate, toPercent, roundNum, toDurationFormat
import { getColor,  getFactDateRange, toDisplayDate,roundNum } from '../../../util/ChartUtils';

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, BarElement, Title, Tooltip, Legend);

const AccountSummaryCharts = (props) => {
    console.log('in DashboardCharts')
    let data = props.data;
    let range = props.range;

    if (data == null || data.length < 1) {
        return null;
    }

    let dateRange = getFactDateRange(range.startDate, range.endDate)
    //console.log('range',dateRange);

    if (dateRange.length > data.length) {
        //have missing periods that need to be fixed
        for (let i = 0; i < dateRange.length; i++) {
            //console.log(dateRange[i].factDate)
            //needs to be != and not !== as that compares type and value
            //the number is sometimes technically a string
            if (i >= data.length || dateRange[i].factDate != data[i].factDate) {
                //console.log('missing', dateRange[i].factDate)
                data.splice(i, 0, { factDate: dateRange[i].factDate })
            }
        }
    }

    //console.log(dateRange)
    let dates = [];
    let sessions = [];
    let users = [];
    let newusers = [];

    let interactions = [];
    let promptsIn = [];
    let responsesOut = [];

    let promptTokens = [];
    let completionTokens = [];
    let totalTokens = [];

    let costs = [];
    let times = [];
    let sentiments = [];
    let latencies = [];


    let userTotal = 0;
    let sessionTotal = 0;
    let promptTotal = 0;
    let responseTotal =0;
    let interactionTotal = 0;
    let promptTokenTotal = 0;
    let completionTokenTotal = 0;
    let tokenTotal = 0; 
    let costTotal = 0;
    let avgTime = 0;
    let avgLatency = 0;
    let totalLatency = 0;
    let totalTime = 0;

    //build data
    data.forEach((item, i) => {
        //could get date from the range array, or just convert again
        dates.push(toDisplayDate(item.factDate));
        sessions.push(item.sessions);
        sessionTotal += item?.sessions ? item.sessions : 0;
        users.push(item.users);

        userTotal += item?.users ? item.users : 0;

        newusers.push(item.newUsers);

        interactions.push(item.interactionsIn);
        interactionTotal += item?.interactionsIn ? item.interactionsIn : 0;
        promptsIn.push(item.promptsIn);
        promptTotal += item.promptsIn;
        responsesOut.push(item.responsesOut);
        responseTotal += item?.responsesOut ? item.responsesOut : 0;

        promptTokens.push(item.promptTokens);
        completionTokens.push(item.completionTokens);
        totalTokens.push(item.totalTokens);
        tokenTotal += item?.totalTokens ? item.totalTokens : 0;

        costs.push(item.totalCost);
        costTotal += item?.totalCost ? item.totalCost : 0;
        
        times.push(item.avgTime);
        totalTime += item?.duration ? item.duration : 0;
       
        sentiments.push(item.avgSentiment);
        latencies.push(item.avgLatency);
        totalLatency += item?.latency ? item.latency : 0;

    });
    if(sessionTotal > 0) {
        avgTime = totalTime/sessionTotal;
    }
    if(interactionTotal > 0) {
        avgLatency = totalLatency/interactionTotal;
    }


    return (
        <>
            <Row md={2} lg={2}>
                <Col className='mb-5'><div className='chart-card'>
                <div className='chart-title'>{interactionTotal} interactions</div>
                    <Bar data={{
                    labels: dates, datasets: [
                        { label: 'Prompts', data: promptsIn, yAxisID: 'y', backgroundColor: getColor(0), borderColor: getColor(0) },
                        { label: 'Responses', data: responsesOut, yAxisID: 'y', backgroundColor: getColor(1), borderColor: getColor(1) },]
                }}
                    options={{ legend: { display: true, position: 'top' }, 
                    scales: { 
                        y: { 
                            suggestedMin: 0 ,
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                            
                        }, 
                        x: {
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                        }
                    },
                    plugins : {legend : {labels : {usePointStyle : true, boxHeight: 8}, align:'end'}} }} /></div>
                </Col>
                <Col className='mb-5'><div className='chart-card'>
                <div className='chart-title'>{tokenTotal} tokens</div>
                    <Bar data={{
                    labels: dates, datasets: [
                        { label: 'Total Tokens', data: totalTokens, yAxisID: 'y', backgroundColor: getColor(0), borderColor: getColor(0) },
                        { label: 'Prompt Tokens', data: promptTokens, yAxisID: 'y', backgroundColor: getColor(1), borderColor: getColor(1) },
                        { label: 'Completion Tokens', data: completionTokens, yAxisID: 'y', backgroundColor: getColor(2), borderColor: getColor(2) },
                    ]
                }}
                    options={{ legend: { display: true, position: 'top' }, 
                    scales: { 
                        y: { 
                            suggestedMin: 0 ,
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                            
                        }, 
                        x: {
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                        }
                    },
                    plugins : {legend : {labels : {usePointStyle : true, boxHeight: 8}, align:'end'}} }} /></div>
                </Col>
            </Row>
            <Row md={2} lg={2}>
                <Col className='mb-5'><div className='chart-card'>
                <div className='chart-title'>${roundNum(costTotal,6)} total costs</div>
                    <Bar data={{
                    labels: dates, datasets: [
                        { label: 'Cost', data: costs, yAxisID: 'y', backgroundColor: getColor(0), borderColor: getColor(0) },
                        ]
                }}
                    options={{ legend: { display: true, position: 'top' }, 
                    scales: { 
                        y: { 
                            suggestedMin: 0 ,
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                            
                        }, 
                        x: {
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                        }
                    },
                    plugins : {
                        legend : {labels : {usePointStyle : true, boxHeight: 8}, align:'end'},
                        tooltip: {
                            callbacks: {
                                label: (ctx) => {
                                    return ctx.dataset.label + ': ' + ctx.parsed.y
                                }
                            }
                        },
                        } 
                    }} /></div>
                </Col>
                <Col className='mb-5'><div className='chart-card'>
                <div className='chart-title'>{roundNum(avgLatency,0)} ms average latency</div>
                    <Bar data={{
                    labels: dates, datasets: [
                        { label: 'Average Latency', data: latencies, yAxisID: 'y', backgroundColor: getColor(0), borderColor: getColor(0) },]
                }}
                    options={{ legend: { display: true, position: 'top' }, 
                    scales: { 
                        y: { 
                            suggestedMin: 0 ,
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                            
                        }, 
                        x: {
                            border:{dash: [3, 3], color:'#dedede'},
                            grid: {
                                color: '#e3e3e3',
                            }
                        }
                    },
                    plugins : {
                        legend : {labels : {usePointStyle : true, boxHeight: 8}, align:'end'},
                        tooltip: {
                            callbacks: {
                                label: (ctx) => {
                                    return ctx.dataset.label + ': ' + roundNum(ctx.parsed.y,0)
                                }
                            }
                        },
                    } }} /></div>
                </Col>
            </Row>
        </>
    )

}

export default AccountSummaryCharts;